// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1vE3g","order_number":"styles_order_number__3r7KX"};